import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

export default function Spinner() {
  return (
    <div>
      <CircularProgress color="secondary" />
    </div>
  );
}
